import { config } from "../../config";

// Admin users move to the new admin (heapsgo-admin-web); these pages link
// there until they are removed.
export const heapsGoAdminAdminsUrl = (organizationKeyName: string) =>
  `${config.heapsGoAdminUrl}/hgo/${organizationKeyName}/admins`;

export const heapsGoAdminAdminUrl = (
  organizationKeyName: string,
  adminId: string
) => `${heapsGoAdminAdminsUrl(organizationKeyName)}/${adminId}`;
